export const MIN_AUDIO_BYTES = 800;
export const MAX_RECORDING_DURATION_MS = 15000;